<!-- @format -->

@if (question.questionType === "FREE_TEXT") {
  <sis-text-field
    labelHTML="{{ parsedFreeTextQuestion | localizedString }}"
    [control]="control"
    [id]="'enrolment-questionnaire-question-free-text'"
    [textarea]="true" />
}

@if (question.questionType === "LANGUAGE_SELECT" && langQuestion) {
  <h4 [ngClass]="{ required: question.required, valid: control.valid, invalid: control.invalid && control.touched }">
    {{ "ENROLMENT_QUESTIONAIRE_LANG_ANSWER_TITLE" | translate }}
  </h4>
  <div role="radiogroup" [attr.aria-describedby]="'enrolment-questionnaire-question-language-select_errors'">
    @for (langSelect of langQuestion.selections; track langSelect) {
      <div>
        <sis-radio-button
          [translatedLabel]="langSelect.option | localizedString"
          [control]="control"
          [value]="langSelect.value"
          [name]="question.localId" />
      </div>
    }
  </div>
  @if (control.invalid && control.touched) {
    <sis-validation-errors
      [validationErrors]="control.errors"
      [formFieldId]="'enrolment-questionnaire-question-language-select'"
      [ariaLive]="false" />
  }
}
